import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { BirthdayType } from '../../../app/types';
import IcHelpCircle from '../../../assets/images/svg/ic-help-circle.svg';
import { setNodeById, setSelectedNode } from '../../../features/mainSlice';
import Dropdown from '../../shared/Dropdown';
import Tooltip from '../../shared/Tooltip';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 12,
      display: 'flex',
      alignItems: 'center',
      '& > img': {
        marginLeft: 4,
      },
    },
    marginLeft4: {
      marginLeft: 4,
    },
  },
  {
    name: 'Birthday',
  },
);

const Birthday = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { data } = selectedNode || {};
  const { conditions } = data || {};

  const onChange = value => {
    const newNode = {
      ...selectedNode,
      data: {
        ...data,
        conditions: value,
      },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  const menuItems = [
    {
      text: t(`birthday.${BirthdayType.DAY}`),
      value: BirthdayType.DAY,
    },
    {
      text: t(`birthday.${BirthdayType.MONTH}`),
      value: BirthdayType.MONTH,
    },
    {
      text: t(`birthday.${BirthdayType.NEXT_MONTH}`),
      value: BirthdayType.NEXT_MONTH,
    },
  ];

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {t('trigger.birthday')}
        <Tooltip light placement="top" title={t('birthdayTooltip')}>
          <img className={classes.marginLeft8} src={IcHelpCircle} alt="alert" />
        </Tooltip>
      </div>
      <Dropdown
        className={classes.dropdown}
        menuItems={menuItems}
        value={conditions}
        onChange={onChange}
      />
    </div>
  );
};

export default Birthday;
